export default import.meta.ROLLDOWN_FILE_URL_X0VjLp5eIbDPt9fHLW8ANA